module.exports = __webpack_public_path__ + "static/media/marketplace.a618f1a9.jpg";